let header = document.querySelector('header')
let origHeaderPadding = header.offsetHeight
let body = document.body
body.style.paddingTop = `${origHeaderPadding}px`
window.addEventListener('scroll', () => {
  let header = document.querySelector('header')
  let scrollPos = window.pageYOffset
  let newHeaderPadding = header.offsetHeight
  let target = 120
  if (scrollPos > target) {
    newHeaderPadding = header.offsetHeight
    header.classList.add('scrolled')
  } else {
    header.classList.remove('scrolled')
    newHeaderPadding = origHeaderPadding
  }
  if (scrollPos > target + 10) {
    body.style.paddingTop = `${newHeaderPadding}px`
  } else {
    body.style.paddingTop = `${origHeaderPadding}px`
  }
})